import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import FacilityBinPickingSimulation from './components/BinPicking/FacilityBinPickingSimulation';
import MobileSearchView from './components/BinPicking/MobileSearchView';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/remote/:sessionId" element={<MobileSearchView />} />
        <Route path="/remote" element={<MobileSearchView />} />
        <Route path="/*" element={<FacilityBinPickingSimulation />} />
      </Routes>
    </Router>
  );
}

export default App;